import { addDisposableListener } from 'vscode/vscode/vs/base/browser/dom';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { registerTerminalContribution } from '../../../terminal/browser/terminalExtensions.js';

class TerminalHighlightContribution extends Disposable {
    static { this.ID = 'terminal.highlight'; }
    static get(instance) {
        return instance.getContribution(TerminalHighlightContribution.ID);
    }
    constructor(_instance, processManager, widgetManager) {
        super();
        this._instance = _instance;
    }
    xtermOpen(xterm) {
        const screenElement = xterm.raw.element.querySelector('.xterm-screen');
        this._register(addDisposableListener(screenElement, 'mousemove', (e) => this._tryShowHighlight(screenElement, xterm, e)));
        const viewportElement = xterm.raw.element.querySelector('.xterm-viewport');
        this._register(addDisposableListener(viewportElement, 'mousemove', (e) => this._tryShowHighlight(screenElement, xterm, e)));
        this._register(addDisposableListener(xterm.raw.element, 'mouseout', () => xterm.markTracker.showCommandGuide(undefined)));
        this._register(xterm.raw.onData(() => xterm.markTracker.showCommandGuide(undefined)));
    }
    _tryShowHighlight(element, xterm, e) {
        const rect = element.getBoundingClientRect();
        if (!rect) {
            return;
        }
        const mouseCursorY = Math.floor(e.offsetY / (rect.height / xterm.raw.rows));
        const command = this._instance.capabilities.get(2 )?.getCommandForLine(xterm.raw.buffer.active.viewportY + mouseCursorY);
        if (command && 'getOutput' in command) {
            xterm.markTracker.showCommandGuide(command);
        }
        else {
            xterm.markTracker.showCommandGuide(undefined);
        }
    }
}
registerTerminalContribution(TerminalHighlightContribution.ID, TerminalHighlightContribution, false);
